import {course_getCourseClassStudents_Api,} from 'apis'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import React, {useContext, useMemo} from 'react'
import {bindQueryParam,} from 'views/AppLocals/functions/routerHelper'
import {getResponseItems} from 'views/Shared'
import {getId} from "../../../../../apis/model/base";
import getTitle from "../../../../../helpers/getTitle";
import useTranslate from "../../../../../modules/local/useTranslate";
import {Select} from "antd";
import {dropdownComponents} from "../../../../AppLocals/custom/ReactSelectComponents";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import DrawDialog from "../../../../../components/drawer/dialog/DrawDialog";
import classNames from "classnames"

export const CourseClassStudentPicker = ({course_class_id, children, onChange, defaultValue = [], placeholder, ...props}) => {
    const t = useTranslate();
    const {isLg} = useContext(LayoutContext)

    const apiInfo = course_getCourseClassStudents_Api

    const cacheId = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', course_class_id),
            ].join('/'),
        [course_class_id]
    )

    const {response, isLoading} = useAsyncWithCache({
        cacheId,
        apiInfo,
        query: bindQueryParam({id: course_class_id}),
    })

    const items = getResponseItems(response);
    const options = Array.from(items).map((option) => {
        const student = option?.student
        return {
            value: getId(student),
            label: getTitle(student),
        }
    })

    if (isLg) return (
        <Select
            className="w-full"
            placeholder={placeholder}
            suffixIcon={<dropdownComponents.DropdownIndicator/>}
            value={defaultValue}
            onChange={onChange}
            options={options}
            {...props}
        >
            {children}
        </Select>
    )

    return (
        <DrawDialog
            width={540}
            title={placeholder}
            closable={true}
            // container="root"
            component={
                <Select
                    className="w-full"
                    placeholder={placeholder}
                    suffixIcon={<dropdownComponents.DropdownIndicator/>}
                    value={defaultValue}
                    options={options}
                    {...props}
                >
                    {children}
                </Select>
            }
        >
            {(isToggle, toggle) => isToggle && (
                <div className="flex flex-col gap-1">
                    {
                        items.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className={
                                        classNames(
                                            "p-2 flex items-center justify-between",
                                            defaultValue.includes(item?.student?.id) ? "text-primary font-bold" : "font-medium"
                                        )
                                    }
                                    onClick={() => {
                                        const exists = defaultValue.includes(item?.student?.id)
                                        const _value = exists
                                            ? defaultValue.filter(id => id !== item?.student?.id)
                                            : [...defaultValue, item?.student?.id]
                                        onChange(_value)
                                        toggle();
                                    }}
                                >
                                    <div>{getTitle(item?.student)}</div>
                                </div>
                            )
                        })
                    }
                </div>
            )}
        </DrawDialog>
    )
}

export default CourseClassStudentPicker
